import styled from "styled-components";
import theme from "../constants/theme";

export default styled.div({
  backgroundColor: theme.palette.secondary.light,
  padding: theme.spacing(7),
  [theme.breakpoints.only("xs")]: {
    padding: theme.spacing(5),
  },
});
